module.exports = __webpack_public_path__ + "static/media/kiernan-steel-ltd.79a90ed5.jpg";